export const statusMapping = {
  true: "connect",
  false: "disconnect",
  // offline: "offline",
};